/**
 * Shared comparators for ag-grid columns
 * These comparators provide consistent sorting behavior across the application
 */

/**
 * String comparator for ag-grid columns
 * Performs case-insensitive, locale-aware string comparison using Spanish locale
 * Handles null/undefined values gracefully
 * 
 * @param valueA - First value to compare
 * @param valueB - Second value to compare
 * @returns Negative number if valueA < valueB, positive if valueA > valueB, 0 if equal
 */
export function stringComparator(valueA: any, valueB: any): number {
  const a = (valueA ?? '').toString().trim().toLocaleLowerCase();
  const b = (valueB ?? '').toString().trim().toLocaleLowerCase();
  return a.localeCompare(b, 'es', { sensitivity: 'base' });
}

